import {
  Component,
  computed,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import {  ICellRendererParams } from 'ag-grid-community';
import { formatCurrency } from '@angular/common';
import { DscrDocumentService } from 'src/app/components/businesses/finances/dscr-document.service';
import { buildUniqueCellId } from '@app/app/components/grid-components/grid-helpers';

@Component({
  standalone: true,
  templateUrl: './finance-amount-cell.component.html',
  styleUrls: ['./finance-amount-cell.component.scss']
})
export class FinanceAmountCellComponent implements ICellRendererAngularComp {
  private _dscrDocumentService = inject(DscrDocumentService);
  private _params: ICellRendererParams;
  private _cellId = '';
  @HostListener('mouseenter', ['$event'])
  handleMouseEnter(): void {
    this.isCellHover.set(true);
  }

  @HostListener('mouseleave', ['$event'])
  handleMouseLeave(): void {
    this.isCellHover.set(false);
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleKeydownEsc(event: KeyboardEvent) {
    this._params.api.stopEditing(true);
  }

  public documentId = computed(() => this._dscrDocumentService.documentId());
  public isDocumentVisible = computed(() => this._dscrDocumentService.isDocumentVisible());
  public documentControlCellId = computed(() => this._dscrDocumentService.documentControlCellId());

  public isCellHover = signal(false);
  public displayValue = signal('');
  public isDocumentControlCell = computed(() => this.documentControlCellId() === this._cellId);

  public shouldBeVisibleToggleButton = computed(() => {
    return (this.documentId() > 0 && (this.isCellHover() || this.isDocumentControlCell()));
  });

  public buttonText = computed(() => {
    return (this.isDocumentControlCell() && this.isDocumentVisible())
        ? 'Close'
        : 'Open';
  });

  agInit(params: ICellRendererParams): void {
    this._params = params;
    const formattedValue = formatCurrency(params.value, 'en-US', '$');
    this.displayValue.set(formattedValue);
    this._cellId = buildUniqueCellId(params.node.id, params.column?.getColId());
    if (params.node.id) {
      const rowNode = this._params.api.getRowNode(params.node.id);
      this._dscrDocumentService.documentId.set(rowNode?.data.documentId || -1);
    }
  }

  refresh(params: ICellRendererParams) {
    this._params = params;
    return false;
  }

  toggleIsDocumentVisible(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.isDocumentVisible()) {
      if (this.isDocumentControlCell()) {
        // clicked close
        this._dscrDocumentService.isDocumentVisible.set(false);
        this._dscrDocumentService.documentControlCellId.set('');
      } else {
        // document is visible, user clicked open on a different cell
        this._dscrDocumentService.isDocumentVisible.set(false);

        setTimeout(() => {
          this._dscrDocumentService.documentControlCellId.set(this._cellId);
          this._dscrDocumentService.isDocumentVisible.set(true);
        })
      }
    } else {
      // open doc viewer if id looks valid
      if (this.documentId() > 0) {
        this._dscrDocumentService.isDocumentVisible.set(true);
        this._dscrDocumentService.documentControlCellId.set(this._cellId);
      }
    }
    setTimeout(() => this._params.api.stopEditing(true));
  }

}
